import { TextField, TextFieldProps } from "@mui/material";

export default function BaseInput(props: TextFieldProps) {
  return <TextField {...props}
    size="small"
  />
}